// Market, trading, and financial components
import { defineAsyncComponent } from 'vue'

export default {
  CommercialScada: defineAsyncComponent(
    () => import('../commercial_scada/commercial_scada.vue')
  ),
  Liquidity: defineAsyncComponent(() => import('../liquidity/liquidity.vue')),
  LiquidityMinMaxExpectedChart: defineAsyncComponent(
    () => import('../liquidity/min_max_expected_chart.vue')
  ),
  MarketOutlookIndex: defineAsyncComponent(
    () => import('../market_outlook/index.vue')
  ),
  MarketPricesIndex: defineAsyncComponent(
    () => import('../market_prices/index.vue')
  ),
  MarketplaceProducts: defineAsyncComponent(
    () => import('../marketplace_products/index.vue')
  ),
  PpaPrices: defineAsyncComponent(() => import('../ppa_prices/ppa_prices.vue'))
}
